export default __webpack_public_path__ + "static/profile-b7e98288695c5cb882f44a3bf50217e3.png";